<template>
<div id="page-carga_adjuntos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Cargar Adjuntos a Manifestación" class="elevation-1 px-5 py-3" >
                   
                    <v-card-text>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <p class="text-justify" >
                                            <v-icon color="indigo" >info</v-icon>                                            
                                            <strong>El archivo ZIP debe ser nombrado de la siguiente manera: 
                                                <br/> - Para Manifestación de Valor utilizar el formato: <strong> [AñoPedimento]_[Aduana-Patente-Pedimento].zip </strong> (ej. <span style="color:blue">2026_240-1234-9000005.zip</span>)
                                                <br/>Los nombres de los archivos dentro del ZIP no deben contener acentos ni caracteres especiales 
                                                    y deben tener un tipo de documento válido al inicio (Ver <v-btn small outlined text @click="showApendice()" >Apéndice de Tipos de Documentos</v-btn>, ej. 170_Factura123.xml)</strong>
                                        </p>

                                        <v-flex xs12>
                                            <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                            <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked" >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn @click.native="modal=false; reset();" >
                                <v-icon>cancel</v-icon> Cancelar</v-btn>
                                <v-btn v-if="false" color="success" >
                                    <v-icon>done</v-icon>Guardar
                                </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
        
    </v-container>

    <!-- MODAL Apendice-25-Tipos de Documentos -->
    <v-dialog v-model="modalApendice" max-width="80%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modalApendice = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Tipos de Documentos</strong>
                    </span>
                </v-card>                    
            </v-card-title>
            <v-card-text>
                <v-client-table ref="vuetableApendice" :data="apendice_items" :columns="columns" class="elevation-2 pa-2" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>                                                                        
                </v-client-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalApendice = false" >
                    <v-icon>cancel</v-icon>Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.cliente = this.$local_storage.get("id_cliente");
    },
    data() {
        return {
            fab: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "E-Drive",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Cargar Adjuntos Manifestación",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            modalApendice: false,
            apendice_items: [],
            columns: [
                "clave",
                "descripcion"     
            ],

            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {        
        validarPatronPedimento(pedimento) {
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        pickFile() {
            this.$refs.file_input.click()
        },

        onFilePicked(e) {
            try {
                const files = e.target.files;
                
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;
                                        
                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var nombre = this.name_file.split(".");
                    var split = [];
                    var valido = false;

                    if (nombre.length == 2){                        
                        split = nombre[0].split("_");
                        if (split.length == 2){
                            const patternPedimento = /^[0-9]{4}_{1}[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
                            if (patternPedimento.test(nombre[0])){
                                valido = true;
                            }                            
                        } 
                    } 

                    if (valido == false){
                        this.reset();
                        this.$swal({
                            type: "warning",
                            title: "Favor de verificar",
                            text: "El archivo ZIP debe tener el nombre correcto, con año y número de pedimento.",
                            footer: "Ejemplo: 2026_240-1234-9000005.zip"
                        });
                    } else {                        
                        this.uploadFile(files[0], nombre[0]);                        
                    }                    

                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            
            var rfcActual = this.$local_storage.get("rfc").toString().trim().toUpperCase();
            var thisObj = this;
            
            var keyFile = rfcActual+"/mv_pendientes/" + thisObj.name_file;
            
            var datos = {
                key: keyFile,
                bucket: "sftp.econnectpro.mx",
                type: thisObj.type_file
            }
            axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {headers:{'Content-Type': thisObj.type_file}})
                        .then((res) => {
                            thisObj.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se cargó correctamente.",
                                footer: '',
                            });                            
                        })                            
                        .catch((error)=>{                            
                            thisObj.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });
                            console.log(error);
                        }).then(() => {
                            thisObj.$root.$dialogLoader.hide();
                            thisObj.reset();
                        });
                        
                    } else {
                        thisObj.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    thisObj.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);                    
                }).then(() => {
                    thisObj.$root.$dialogLoader.hide();
                    thisObj.reset();
                });
        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        showApendice(){
            if (this.apendice_items.length <= 0){            
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');                                                
                    axios.post(this.$hostname + 'apendices/lista/', {tabla:25})
                        .then((res) => {
                            this.apendice_items = res.data;
                            for( var k in this.apendice_items){
                                if(this.apendice_items[k].recibe_facturas!=undefined && this.apendice_items[k].recibe_facturas==1)
                                    this.apendice_items[k].recibe_facturas = "Si";
                                else
                                    this.apendice_items[k].recibe_facturas = "No";
                                
                                if(this.apendice_items[k].recibe_layouts!=undefined && this.apendice_items[k].recibe_layouts==1)
                                    this.apendice_items[k].recibe_layouts = "Si";
                                else
                                    this.apendice_items[k].recibe_layouts = "No";
                            }
                            this.modalApendice =true;
                        })
                        .catch((error) => {                        
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al obtener los registros del apéndice",
                                footer: "",
                            });
                            console.log(error);                    
                        }).then(() => {                        
                            this.$root.$dialogLoader.hide();                        
                        });
            } else {
                this.modalApendice =true;
            }
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
    }
    
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>